export const style = {
  root: 'bg-slate1 -space-y-px rounded-md',
  item: 'group relative flex w-full cursor-pointer border border-slate6 p-4 first-of-type:rounded-tl-md first-of-type:rounded-tr-md last-of-type:rounded-bl-md last-of-type:rounded-br-md focus:outline-hidden radix-state-checked:z-10 radix-state-checked:border-blue8 radix-state-checked:bg-blue4',
  textWrapper: 'text-md ml-3 flex flex-col text-left',
  name: 'block font-medium text-slate12 group-radix-state-checked:text-blue12',
  description: 'block text-slate11 group-radix-state-checked:text-blue11',
};
